import { formatDate } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, catchError, of, throwError, BehaviorSubject, Subject, distinctUntilChanged, from } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment'
import { AuthGuardService } from '../guard/auth-guard/auth-guard.service';

// const idTok: any = localStorage.getItem('id_token') == null ? '' : localStorage.getItem('id_token')
// const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
// let httpOptions: any;
const contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
// if (isIEOrEdge) {
//   httpOptions = {
//     headers: new HttpHeaders({
//       'Content-Type': contentType,
//       'Cache-Control': 'no-cache',
//       'Pragma': 'no-cache',
//       'Authorization': idTok,
//       'IdToken': idTok
//     })
//   };
// } else {
//   httpOptions = {
//     headers: new HttpHeaders({
//       'Content-Type': contentType,
//       'Authorization': idTok,
//       'IdToken': idTok
//     })
//   };
// }
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  discussionChatURL = '/';
  isMockChatRes: boolean = true;
  todayDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
  currentTime: any;
  mockChatRes = {
    receivedChatMsg: 'Yes...',
    date: this.todayDate,
    time: ''
  };
  submittedQnAnsArr: any;
  discDataArray: any = [];
  enablelist: boolean = false;
  dateFilter: any = '';
  categoryFilter: any = '';
  statusFilter: any = '';
  groupFilter: any = '';
  searchDiscVal: any = '';
  selectedAffilate: any = '';
  langCode: any = '';
  // Backing field for the `affiliate` getter/setter below - never read/write this directly,
  // use `this.affiliate` (or setaffiliate()) instead.
  private _affiliate = '';
  // Backing field for the `languagae` getter/setter below - never read/write this directly,
  // use `this.languagae` (or setlangugae()/getlanguage()) instead.
  private _languagae: any;
  managerMailid: any;
  approverName: any;
  managerid: any;
  newmanagerid: any;
  defaultlang: any;
  affiliateConcatStr: string = '&affiliate=';
  defaultLangConcatStr: string = '&defaultlang=';
  affConcatStr: string = '?affiliate=';
  discidConcatStr: string = '?disclosureId=';
  private readonly triggerHomesource = new BehaviorSubject(null);
  isFormReset = this.triggerHomesource.asObservable();
  private triggerAction = new Subject<void>();
  triggerAction$ = this.triggerAction.asObservable();
  private triggerDiscussion = new Subject<void>();
  triggerDiscussion$ = this.triggerDiscussion.asObservable();
  private triggerCountermeasure = new Subject<void>();
  triggerCountermeasure$ = this.triggerCountermeasure.asObservable();
  private refreshApproval = new Subject<void>();
  refreshApproval$ = this.refreshApproval.asObservable();
  // Emitted once AppComponent finishes processing a fresh login (roles/affiliate/tokens
  // written to localStorage, identity verified) - lets already-constructed components like
  // HeaderComponent (which reads Affiliate/roles at construction time, before login
  // finishes on first-ever sign-in) re-run their own role/affiliate/menu fetch in-place,
  // without relying on a full page reload.
  private readonly authReadySource = new Subject<void>();
  authReady$ = this.authReadySource.asObservable();
  defaultdate: any;
  defaultDateConcatStr: string = '&defaultdate=';
  private filterStsSubject = new BehaviorSubject<string>('');
  public filterSts$ = this.filterStsSubject.asObservable().pipe(
    distinctUntilChanged()
  );
  // Reference-counted "page busy" tracker so multiple independent tasks loading data on the
  // SAME page concurrently (e.g. HomeComponent's own category/status fetch AND its child
  // DisclosureTableComponent's own, separate disclosure-list fetch, which each used to call
  // NgxSpinnerService.show()/hide() directly and independently) share ONE spinner overlay
  // state instead of fighting over it. Previously, whichever task finished first called
  // .hide() directly and turned the overlay off globally, even while the OTHER task was
  // still loading - so users saw the loader disappear before all of the page's initial data
  // had actually arrived. Use beginLoading()/endLoading() (always in pairs, endLoading()
  // exactly once per beginLoading(), on success OR error) instead of calling
  // NgxSpinnerService.show()/hide() directly wherever more than one independent load can be
  // in flight for the same view - the spinner only actually hides once the count reaches 0.
  private pageBusyCount = 0;
  constructor(private http: HttpClient, private readonly authSrv: AuthGuardService, private readonly spinnerService: NgxSpinnerService) { }

  beginLoading(): void {
    this.pageBusyCount++;
    this.spinnerService.show();
  }

  endLoading(): void {
    this.pageBusyCount = Math.max(0, this.pageBusyCount - 1);
    if (this.pageBusyCount === 0) {
      this.spinnerService.hide();
    }
  }

  // SECURITY: Build URLs with proper query parameter encoding to prevent HTTP parameter injection
  private buildSecureUrl(baseUrl: string, params: { [key: string]: any }): string {
    const queryString = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
      .join('&');
    
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  }

  // The user's roles (e.g. "TMN-User", "TMN-Admin") are persisted as JSON so every reader
  // gets back a real array and can check membership with `.includes(...)` reliably, instead
  // of the previous approach of storing an array via `localStorage.setItem('roles', arr)`
  // (which silently coerces it to a comma-separated STRING via `arr.toString()`) and then
  // relying on substring `.includes(...)` / index checks against that string elsewhere -
  // fragile and prone to false positives/negatives for multi-role users.
  setStoredRoles(roles: string[]): void {
    localStorage.setItem('roles', JSON.stringify(roles ?? []));
  }

  // Reads the roles array back out. Tolerates the OLD comma-separated-string format still
  // sitting in localStorage from a session that hasn't gone through a fresh login/reload
  // since this change, so an in-progress session isn't broken by the storage format
  // migration - it'll get rewritten as real JSON the next time setStoredRoles() runs.
  getStoredRoles(): string[] {
    const raw = localStorage.getItem('roles');
    if (!raw) {
      return [];
    }
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return raw.split(',').map(r => r.trim()).filter(Boolean);
    }
  }

  // Dynamically get HTTP options with the current id token from memory
  private getHttpOptions() {
    const idTok = this.authSrv.getIdToken() || '';
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let httpOptions: any;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': contentType,
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Authorization': idTok,
          'IdToken': idTok
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': contentType,
          'Authorization': idTok,
          'IdToken': idTok
        })
      };
    }
    return httpOptions;
  }
  
  //tokencheck
  async getTokens(tokenBody: any) {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': contentType, 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', })
      };
    } else {
      httpOptions = { headers: new HttpHeaders({ 'Content-Type': contentType, }) };
    }
    return await this.http.post(environment?.tokenURL, tokenBody, httpOptions).pipe(map((response: any) => response)).pipe(catchError(this.handleError)).toPromise();
  }

  // Runs once at app bootstrap (see provideAppInitializer in app.config.ts) so any component
  // that reads authSrv's tokens in its constructor (e.g. HeaderComponent) never races the
  // silent refresh that repopulates memory after a reload - Angular won't render ANY
  // component until this resolves.
  async initializeSessionFromRefreshToken(): Promise<void> {
    try {
      const refreshTokenValue = this.authSrv.getRefreshToken();
      if (!refreshTokenValue || (this.authSrv.getAccessToken() && this.authSrv.getIdToken())) {
        return;
      }
      const res: any = await this.getTokens(new URLSearchParams({
        'grant_type': 'refresh_token',
        'client_id': environment.clientId,
        'refresh_token': refreshTokenValue
      }).toString());
      if (res?.id_token && res?.access_token && res?.refresh_token) {
        this.authSrv.setTokens({
          idToken: res.id_token,
          accessToken: res.access_token,
          refreshToken: res.refresh_token,
          newIdTokenKey: res.id_token
        });
      }
    } catch (error) {
      // Never let a failure here block app bootstrap - app.component.ts's
      // initializeTokenRefreshWorkflow() still runs afterward and handles a genuinely
      // invalid/expired session by redirecting to login.
      console.error('[initializeSessionFromRefreshToken] Silent token refresh failed on app bootstrap:', error);
    }
  }

  // Used by the auth interceptor to refresh the token and return the new id_token, or null on failure
  refreshTokenForInterceptor(): Observable<string | null> {
    const refreshTokenValue = this.authSrv.getRefreshToken();
    if (!refreshTokenValue) {
      return of(null);
    }

    const params = new URLSearchParams({
      'grant_type': 'refresh_token',
      'client_id': environment.clientId,
      'refresh_token': refreshTokenValue
    });

    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': contentType }) };

    return this.http.post(environment?.tokenURL, params.toString(), httpOptions).pipe(
      map((res: any) => {
        if (res?.id_token && res?.access_token && res?.refresh_token) {
          this.authSrv.setTokens({
            idToken: res.id_token,
            accessToken: res.access_token,
            refreshToken: res.refresh_token,
            newIdTokenKey: res.id_token
          });
          return res.id_token as string;
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }

  trigger() {
    this.triggerAction.next();
  }

  triggerDiscussions() {
    this.triggerDiscussion.next();
  }

  triggerCountermeasures(message: any) {
    this.triggerCountermeasure.next(message);
  }

  triggerHomeFn(val: any) {
    this.triggerHomesource.next(val);
  }

  refreshApprovals() {
    this.refreshApproval.next();
  }

  notifyAuthReady(): void {
    this.authReadySource.next();
  }

  setSubmittedQnAns(data: any) {
    this.submittedQnAnsArr = data;
  }

  setFilterSts(value: string) {
    if (this.filterStsSubject.value !== value) {
      this.filterStsSubject.next(value);
    }
  }

  getFilterSts(): string {
    return this.filterStsSubject.value;
  }

  getSubmittedQnAns() {
    return this.submittedQnAnsArr;
  }
  disclosurelist(discArr: any) {
    if (discArr[0] != null && discArr.length > 0) {
      this.enablelist = true;
    } else {
      this.enablelist = false;
    }
  }

  setaffiliate(data: any) {
    this._affiliate = data;
  }
  // Same rationale/fallback chain as the `languagae` getter below: `_affiliate` is normally
  // set once via setaffiliate(), which several callers only do AFTER an affiliate-lookup
  // that can itself silently fail for an edge-case user (see the onGetRole() bug fixed
  // 2026-09-02) - so every `&affiliate=`/`?affiliate=` built anywhere in this service must
  // be resilient to `_affiliate` never having been set, the same way `languagae` now is.
  // SECURITY: Never fall back to localStorage - affiliate MUST come from JWT claims only
  get affiliate(): any {
    return this._affiliate || '';
  }
  setlangugae(data: any) {
    this._languagae = data;
  }
  getlanguage() {
    return this.languagae;
  }
  // Every `&lang=` query param built anywhere in this service goes through this getter (all
  // existing `this.languagae` references automatically use it, no call-site changes needed).
  // `this._languagae` is normally set once via setlangugae(), which itself depends on
  // `localStorage['langCode']` having been populated by the login flow - for a user where
  // that never happened (e.g. the onGetRole() affiliate-lookup-miss bug), `_languagae` would
  // stay undefined for the rest of the session, and every API call here would literally
  // embed `&lang=undefined` in its URL, breaking every endpoint that actually depends on it
  // (getAffiliatesList was the one exception, since its own URL hardcodes 'null' for lang
  // regardless). This getter guarantees a real, non-empty value no matter what: falls back
  // to whatever is in localStorage, and finally to 'en' if even that's missing.
  get languagae(): any {
    return this._languagae || localStorage.getItem('langCode') || 'en';
  }
  setmanagerId(id: any) {
    this.managerid = id;
  }
  getmanagerId() {
    return this.managerid
  }
  setnewManagerMailid(id: any) {
    this.newmanagerid = id;
  }
  getnewManagerMailid() {
    return this.newmanagerid;
  }
  setapproverName(name: any) {
    this.approverName = name;
  }
  getapproverName() {
    return this.approverName
  }
  setmanagerMailid(id: any) {
    this.managerMailid = id;
  }
  getmanagerMailid() {
    return this.managerMailid
  }

  setdefaultlang(value: any) {
    this.defaultlang = value
  }

  getdefaultlang() {
    return this.defaultlang
  }

  setdefaultdate(value: any) {
    this.defaultdate = value
  }

  getdefaultdate() {
    return this.defaultdate
  }
  //home
  // SECURITY (AppSec High Finding #4 - "Client-supplied administrator flag on admin
  // endpoints"): `isAdmin` is a plain client-supplied query parameter - it CANNOT be trusted
  // as an authorization decision on its own, only as a rendering hint. The adminStack Lambda
  // behind this endpoint MUST independently derive the admin decision from the caller's
  // verified roles claim (the same bearer token already sent via the Authorization/IdToken
  // headers below) and ignore this parameter for anything privilege-related - otherwise any
  // caller with a valid (even non-admin) token can request `isAdmin=Y` directly (e.g. via
  // curl) and receive admin-only data. See ADMIN.md/security-assessment notes - this cannot
  // be fully closed from the UI alone.
  getCategory(isAdmin: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getCategoryDetails/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //home
  getCategoryForUser(isAdmin: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getCategoryForUser/{proxy+}', {
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'affiliate': this.affiliate,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //homeCategorydropdown
  getCategoryForDropdown(isAdmin: any, body: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getCategoryForDropdown/{proxy+}', {
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'affiliate': this.affiliate,
      'defaultdate': this.defaultdate,
      'isArchive': body.isArchive
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getCountermeasureTypes(body: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getCountermeasureTypes/{proxy+}', {
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'affiliate': this.affiliate,
      'defaultdate': this.defaultdate,
      'isArchive': body.isArchive
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //admin
  addCategory(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'insertCategory/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getPrimaryCategory
  getPrimaryCategory(): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getPrimaryCategory/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //getIconList
  getIconList(): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getIconList/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  publishFlag(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'updatePublishFlag/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }


  //insertDiscRes
  insertDiscRes(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'insertDisclosureResponse/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //updatedislosure by submitter
  updateDiscRes(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'updateDisclosure/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  updateCountermeasures(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'counterMeasures/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //updatedislosure by approver
  updateDiscByApprover(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'updateDisclosureByApprover/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getDisclosureByUser
  getDisclosureByUser(body: any): Observable<any> {
    const categoryFilterParam = '?categoryNameFilter=';
    const categoryFilterQuery = body.categoryNameFilter && body.categoryNameFilter.length > 0
      ? JSON.stringify(body.categoryNameFilter)
      : undefined;
    const statFilterParam = '&statFilter=';
    const statFilterQuery = body.statFilter && body.statFilter.length > 0
      ? encodeURIComponent(JSON.stringify(body.statFilter))
      : undefined;
    
    let url = environment?.disclosureStack + 'getDisclosureByUser/{proxy+}';
    if (categoryFilterQuery) {
      url += categoryFilterParam + categoryFilterQuery;
    } else {
      url += categoryFilterParam;
    }
    if (statFilterQuery) {
      url += statFilterParam + statFilterQuery;
    } else {
      url += statFilterParam;
    }
    url += '&screenName=' + (body.screenName === 'Unauthorized' ? '' : body.screenName) +
      '&filterStatus=' + body.filterStatus + '&roles=' + body.roles + '&daysRange=' + body.daysRange + this.defaultDateConcatStr + this.defaultdate +
      this.affiliateConcatStr + this.affiliate + '&lang=' + this.languagae + this.defaultLangConcatStr + this.defaultlang + '&startDate=' + body.startDate + '&endDate=' + body.endDate + '&groupFilter=' + body.groupFilter +
      '&limit=' + body.limit + '&pageSize=' + body.pageSize + '&tagFilter=' + body.tagFilter + '&searchAny=' + body.searchAny + '&sortOrder=' + body.sortOrder + '&colName=' + body.colName
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getDisclosureResponse(disclosureId: any, screenName?: any, affiliate?: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getDisclosureResponseV2/{proxy+}', {
      'disclosureId': disclosureId,
      'affiliate': affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate,
      'screenName': screenName
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  getArchiveResponse(disclosureId: any, screenName?: any, affiliate?: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getArchiveDisclosureResponse/{proxy+}', {
      'disclosureId': disclosureId,
      'affiliate': affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate,
      'screenName': screenName
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //deleteDisclosure
  deleteDisclosure(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'deleteDisclosure/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  getHistoricData(body: any): Observable<any> {
    const categoryFilterParam = '?categoryNameFilter=';
    const categoryFilterQuery = body.categoryNameFilter && body.categoryNameFilter.length > 0
      ? JSON.stringify(body.categoryNameFilter)
      : undefined;
    const statFilterParam = '&statFilter=';
    const statFilterQuery = body.statFilter && body.statFilter.length > 0
      ? encodeURIComponent(JSON.stringify(body.statFilter))
      : undefined;
    
    let url = environment?.disclosureStack + 'getArchiveDisclosures/{proxy+}';
    if (categoryFilterQuery) {
      url += categoryFilterParam + categoryFilterQuery;
    } else {
      url += categoryFilterParam;
    }
    if (statFilterQuery) {
      url += statFilterParam + statFilterQuery;
    } else {
      url += statFilterParam;
    }
    url += '&screenName=' + body.screenName +
    '&filterStatus=' + body.filterStatus + '&roles=' + body.roles + '&daysRange=' + body.daysRange + this.defaultDateConcatStr + this.defaultdate +
    this.affiliateConcatStr + this.affiliate + '&lang=' + this.languagae + this.defaultLangConcatStr + this.defaultlang + '&startDate=' + body.startDate + '&endDate=' + body.endDate + '&groupFilter=' + body.groupFilter +
    '&limit=' + body.limit + '&pageSize=' + body.pageSize + '&searchAny=' + body.searchAny + '&sortOrder=' + body.sortOrder + '&colName=' + body.colName
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getDiscussion
  getDiscussion(disclosureId: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.notificationStack + 'getDiscussion/{proxy+}', {
      'disclosureId': disclosureId,
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //insertDiscussion
  insertDiscussion(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.notificationStack + 'insertDiscussion/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getApprovalFlow
  getApprovalFlow(categoryId: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getApprovalFlow/{proxy+}', {
      'categoryId': categoryId,
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getAllStatusOfDisclosure
  getAllStatusOfDisclosure(body: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getAllStatusOfDisclosure/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate,
      'isArchive': body.isArchive
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //getTagName
  getTagName(): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'getTagName/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getStatusCount
  // getStatusCount(userId: any, roles: any): Observable<any> {
  //   const url = environment?.disclosureStack + 'getStatusCount/{proxy+}' + '?roles=' + roles + this.affiliateConcatStr + this.affiliate + '&lang=' + this.languagae + this.defaultLangConcatStr + this.defaultlang;

  //   return this.http.get(url, httpOptions).pipe((response: any) => response);
  // }

  getStatusCount(userId: any, body: any, type: any): Observable<any> {
    const categoryFilterParam = '?categoryNameFilter=';
    const categoryFilterQuery = body.categoryNameFilter && body.categoryNameFilter.length > 0
      ?  JSON.stringify(body.categoryNameFilter)
      : undefined;
    const statFilterParam = '&statFilter=';
    const statFilterQuery = body.statFilter && body.statFilter.length > 0
      ? encodeURIComponent(JSON.stringify(body.statFilter))
      : undefined;

    let url = environment?.disclosureStack + 'getStatusCount/{proxy+}';
    if (categoryFilterQuery) {
      url += categoryFilterParam + categoryFilterQuery;
    } else {
      url += categoryFilterParam;
    }
    if (statFilterQuery) {
      url += statFilterParam + statFilterQuery;
    } else {
      url += statFilterParam;
    }
    url += '&screenName=' + body.screenName +
      '&filterStatus=' + body.filterStatus + '&roles=' + body.roles + '&daysRange=' + body.daysRange + this.defaultDateConcatStr + this.defaultdate +
      this.affiliateConcatStr + this.affiliate + '&lang=' + this.languagae + this.defaultLangConcatStr + this.defaultlang + '&startDate=' + body.startDate + '&endDate=' + body.endDate + '&groupFilter=' + body.groupFilter +
      '&tagFilter=' + body.tagFilter + '&searchAny=' + body.searchAny + '&type=' + (body.type ? body.type : '');
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //addAttachment
  addAttachment(body: any): Observable<any> {
    const url = environment?.attachmentStack + 'addAttachment/{proxy+}'
    return this.http.post(url, body, this.getHttpOptions()).pipe((response: any) => response);
  }
  getAttachment(disclosureId: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.attachmentStack + 'getAttachment/{proxy+}', {
      'disclosureId': disclosureId,
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //addReferenceDocument
  addReferenceDocument(body: any): Observable<any> {
    const url = environment?.attachmentStack + 'addReferenceDocument/{proxy+}';
    return this.http.post(url, body, this.getHttpOptions()).pipe((response: any) => response);
  }
  //getReferenceDocument
  // SECURITY (AppSec High Finding #4): see getCategory()'s doc comment above - the same
  // client-supplied `isAdmin` caveat applies here; the backend must derive this from the
  // verified roles claim, never trust the query parameter.
  getReferenceDocument(affiliate: any, isAdmin: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.attachmentStack + 'getReferenceDocument/{proxy+}', {
      'screenName': isAdmin,
      'affiliate': affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //update category
  updateCategory(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'updateCategory/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }
  //addquestions
  insertquestion(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'insertQuestionV2/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //updateQuestion
  updateQuestion(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'updateQuestion/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //updateAffliate
  updateAffliate(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      //defaultlang: this.defaultlang
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'updateAffliate/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getquestions
  // SECURITY (AppSec High Finding #4): see getCategory()'s doc comment above - the same
  // client-supplied `isAdmin` caveat applies here; the backend must derive this from the
  // verified roles claim, never trust the query parameter.
  getQuestionData(isAdmin: any, categoryId: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getQuestionDataV2/{proxy+}', {
      'screenName': isAdmin,
      'categoryId': categoryId,
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //reorderCategory
  reorderCategory(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'reorderCategory/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }
  //InsertApprovalFlow
  InsertApprovalFlow(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'addApprovalInfo/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //getAffiliatesList
  getAffiliatesList(): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getAffiliatesList/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //GenerateSts
  GenerateSts(): Observable<any> {
    const url = environment?.aovGenerateSts + 'aovGenerateSts/{proxy+}'
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  
  //reorderQuestions
  reorderQuestions(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'reorderQuestions/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //reorderPrecedence
  reorderPrecedence(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'reorderPrecedence/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  deleteAttachment(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }

    const url = environment?.attachmentStack + 'deleteAttachment/{proxy+}';
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }
  deleteReferenceDocument(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.attachmentStack + 'deleteReferenceDocument/{proxy+}';
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }
  //updateReferenceDocument
  updateReferenceDocument(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.attachmentStack + 'updateReferenceDocument/{proxy+}';
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }
  //reorderRefDoc
  reorderRefDoc(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.attachmentStack + 'reorderDocument/{proxy+}';
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }
  //sendmail
  sendmail(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.notificationStack + 'sendMail/{proxy+}';

    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  //checkApproverId
  checkApproverId(userid: any, affiliate: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.disclosureStack + 'checkApproverId/{proxy+}', {
      'affiliate': affiliate,
      'lang': this.languagae
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  //delegateChange
  delegateChnage(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'delegateApprover/{proxy+}'
    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  private handleError(error: HttpErrorResponse) {
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      errorMsg = `An error occurred: ${error.error.message}`;
    } else if (error.status === undefined) {
      // Previously called location.reload() here - this method is used by getTokens(), the
      // OAuth code-exchange call in the initial login flow, so a transient network hiccup
      // (status undefined, e.g. CORS/timeout) triggered a full page reload in the middle of
      // login and produced the "2-3 flickering loads" symptom. The caller (app.component.ts's
      // getTokens().then(..., onError)) already handles this failure by clearing storage and
      // redirecting back to login, so just propagate the error instead of reloading.
      errorMsg = 'A network error occurred. Please check your connection.';
    } else {
      errorMsg = `Backend returned code ${error.status}`;
    }
    return throwError(() => errorMsg);
  }

  getPresignedUrl(body: any): Observable<any> {
    return this.http.post(environment?.attachmentStack + 'getSignedUrlInfo/{proxy+}', body, this.getHttpOptions()).pipe((response: any) => response);;
  }

  // New uploadFile method - direct upload with base64 encoded file
  uploadFile(payload: any): Observable<any> {
    const idTok = this.authSrv.getIdToken() || '';
    
    
    if (!idTok) {
      console.error('[uploadFile] ERROR: id_token is missing');
    }
    
    const url = environment?.attachmentStack + 'uploadFile/{proxy+}';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': idTok,
      'IdToken': idTok
    });
    
    
    return this.http.post(url, payload, { headers }).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  getaffiliateLanguage() {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getAffiliateLanguages/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getAllLangList() {
    const url = environment?.adminStack + 'getAllLanguages/{proxy+}'
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

   //CheckuserInHR
   // `affiliateOverride` lets a caller scope this lookup to a SPECIFIC affiliate (e.g. one
   // just supplied via a route param, not yet written to this.affiliate) instead of whatever
   // affiliate this service instance currently holds - see
   // ViewQuestionsComponent.isAffiliateAuthorized() (AppSec Critical Finding #1). Omitting it
   // preserves the existing this.affiliate-based behavior for all other call sites.
  checkUserInHR(useremail:any, affiliateOverride?: any, userWorkdayId?: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'checkUserInHR/{proxy+}', {
      'affiliate': affiliateOverride ?? this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'userEmailId': useremail,
      'defaultdate': this.defaultdate,
      ...(userWorkdayId !== undefined ? { 'userWorkdayId': userWorkdayId } : {})
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //getHrMappingDropdown
  getHrMappingDropdown(): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getHrMappingDropdown/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  
   // getOnBehalfOf
  getOnBehalfOf(searchString:any,type: any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getOnBehalfOf/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'searchString': searchString,
      'isDelegateScreen': type,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  getWorkdayData(searchString:any,searchCondition:any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getWorkdayData/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'searchString': searchString,
      'searchConditions': searchCondition,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  

  //getRules
  getRules(category_id:any): Observable<any> {
    // SECURITY: Use buildSecureUrl to prevent HTTP parameter injection
    const url = this.buildSecureUrl(environment?.adminStack + 'getRules/{proxy+}', {
      'affiliate': this.affiliate,
      'lang': this.languagae,
      'defaultlang': this.defaultlang,
      'categoryId': category_id,
      'defaultdate': this.defaultdate
    });
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
  //addRules
  addRules(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'addRules/{proxy+}';

    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  updateRules(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.adminStack + 'updateRules/{proxy+}';

    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  loginApi(username:any, useremail:any, affiliate:any): Observable<any> {

    const affiliateobj = { 
      user_name: username,
      user_email  : useremail,
      affiliate : affiliate,
      region: "",
      lang: this.languagae,
      defaultlang: this.defaultlang
    }
    const payload = { ...affiliateobj }
    const url = environment?.disclosureStack + 'insertLoginLogsData/{proxy+}';

    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  addAdditionalNotes(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'addAdditionalNotes/{proxy+}';

    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  getStackBarChartValue(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getDiscChartCount/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getBarChartValue(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getDiscSubmissionByDivisionChart/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getBarChartValue2(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getDiscBreakDownByYearChart/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getPriceRangeBreakdown(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getPriceRangeBreakdown/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getDiscByStatusChart(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getDiscByStatusChart/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getValueSummaryChart(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getValueSummaryChart/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getTopValuedDisclosuresReport(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getTopValuedDisclosuresReport/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getDiscCountsByCategory(body: any): Observable<any> {
    const url = environment?.reportStack + 'getDiscCountsByCategory/{proxy+}' +
      '?groupName=' + body.groupName +
      '&affiliate=' + body.affiliate +
      '&categoryNameFilter=' + body.subCategory +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  getReports(body: any): Observable<any> {
    const categoryFilterParam = '&categoryNameFilter=';
    const categoryFilterQuery = body.subCategory && body.subCategory.length > 0
      ? JSON.stringify(body.subCategory)
      : undefined;
    const url = environment?.reportStack + 'getAllDetailsDiscList/{proxy+}' +
      '?&affiliate=' + body.affiliate +
      '&groupFilter=' + body.groupFilter 
      + categoryFilterParam + categoryFilterQuery +
      '&disclosureType=' + (body.disclosureType === 'All' ? '' : body.disclosureType) +
      '&disclosureStatus=' + (body.disclosureStatus === 'All' ? '' : body.disclosureStatus) +
      '&daysRange=' + (body.daysRange === 'All' ? '' : body.daysRange) +
      '&startDate=' + body.startDate +
      '&endDate=' + body.endDate +
      '&lang=' + this.languagae +
      '&limit=' + body.limit +
      '&pageSize=' + body.pageSize +
      '&dlORview=' + body.dlORview +
      '&selectedColumns=' + body.selectedColumns +
      this.defaultDateConcatStr + this.defaultdate;
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }

  saveCountermeasureComment(body: any): Observable<any> {
    const affiliateobj = {
      affiliate: this.affiliate,
      lang: this.languagae,
      defaultlang: this.defaultlang,
      defaultdate: this.defaultdate
    }
    const payload = { ...body, ...affiliateobj }
    const url = environment?.disclosureStack + 'counterMeasuresComments/{proxy+}';

    return this.http.post(url, payload, this.getHttpOptions()).pipe((response: any) => response);
  }

  countermeasureTable(body: any): Observable<any> {
    const categoryFilterParam = '?categoryNameFilter=';
    const categoryFilterQuery = body.categoryNameFilter && body.categoryNameFilter.length > 0
      ? JSON.stringify(body.categoryNameFilter)
      : undefined;
    const statFilterParam = '&statFilter=';
    const statFilterQuery = body.statFilter && body.statFilter.length > 0
      ? encodeURIComponent(JSON.stringify(body.statFilter))
      : undefined;
    
    let url = environment?.disclosureStack + 'fetchCounterMeasures/{proxy+}';
    if (categoryFilterQuery) {
      url += categoryFilterParam + categoryFilterQuery;
    } else {
      url += categoryFilterParam;
    }
    if (statFilterQuery) {
      url += statFilterParam + statFilterQuery;
    } else {
      url += statFilterParam;
    }
    url += '&screenName=' + body.screenName +
      '&filterStatus=' + body.filterStatus + '&roles=' + body.roles + '&daysRange=' + body.daysRange + this.defaultDateConcatStr + this.defaultdate +
      this.affiliateConcatStr + this.affiliate + '&lang=' + this.languagae + this.defaultLangConcatStr + this.defaultlang + '&startDate=' + body.startDate + '&endDate=' + body.endDate +
      '&searchAny=' + body.searchAny + '&defaultdate=' + this.defaultdate + '&limit=' + body.limit + '&pageSize=' + body.pageSize + '&groupFilter=' + body.groupFilter + '&type=' + body.type
    return this.http.get(url, this.getHttpOptions()).pipe((response: any) => response);
  }
}

